import { createSelector } from '@ngrx/store';
import { tradingToolsFeature } from './trading-tools.reducer';

export const selectActiveUnderlyingIndex = createSelector(
  tradingToolsFeature.selectUnderlyings,
  tradingToolsFeature.selectActiveUnderlyingIsin,
  (underlyings, isin) => underlyings.findIndex((underlying) => underlying.isin === isin),
);

export const selectActiveUnderlying = createSelector(
  tradingToolsFeature.selectUnderlyings,
  tradingToolsFeature.selectActiveUnderlyingIsin,
  (underlyings, isin) => underlyings.find((underlying) => underlying.isin === isin),
);
